import React from 'react';
import WhatsApp from '../services/WhatsApp';
import { useI18n } from '../i18n/LanguageProvider';
import { contactInfo } from '../data/contactInfo';

const Contact = () => {
  const { t } = useI18n();
  const wa = WhatsApp.link(contactInfo.phone, t('whatsapp.message'));
  const contactLines = [
    `${t('contact.locationLabel')}: ${contactInfo.displayLocation}`,
    `${t('contact.phoneLabel')}: ${contactInfo.phone}`
  ];
  return (
    <section className="section">
      <div className="container grid-2">
        <div>
          <h1>{t('contact.title')}</h1>
          <p className="muted">{t('contact.hours')}</p>
          <ul className="list-clean mt-2">
            {contactLines.map((item, index) => (
              <li className="check" key={index}>{item}</li>
            ))}
          </ul>
          <div className="mt-2" style={{display:'flex', gap:12, flexWrap:'wrap'}}>
            <a className="btn primary" href={wa} target="_blank" rel="noreferrer">{t('contact.whatsapp')}</a>
          </div>
        </div>
        <div className="card" style={{padding:'1.25rem'}}>
          <strong>{t('contact.office')}</strong>
          <iframe
            title="Map"
            style={{
              border: 0,
              width: '100%',
              height: 260,
              borderRadius: 12
            }}
            loading="lazy"
            referrerPolicy="no-referrer-when-downgrade"
            src="https://www.google.com/maps?q=Odessa,+Ukraine&output=embed"
          ></iframe>
        </div>
      </div>
    </section>
  );
};
export default Contact;
